<template>
  <div class="progress-bar-doc">
    <documentation-container :title="title">
      <template slot="content">
        <div class="content-progress">
          <progress-bar :width="20" />
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import DocumentationContainer from '@/components/DocumentationContainer'
import ProgressBar from '@/components/ProgressBar'

export default {
  name: 'adx-progress-bar-doc',
  components: {
    'documentation-container': DocumentationContainer,
    'progress-bar': ProgressBar,
  },
  data() {
    return {
      title: 'Progress Bar',
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
